// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"7a68a032","453":"406f1a2e","477":"4474ebd0","497":"626f7978","633":"9e569ebe","934":"6132b78f","947":"573ce91f"}[chunkId] + ".chunk.js";
};